import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Arts');

export const createDefaultArtset = createAction('Create default artset');
export const fetchArtProducts = createAction('Fetch art products');
export const fetchArtProductsDone = createAction('Fetch art products done');
export const submitArtProductCreate = createAction(
  'Submit art product create',
  (artProduct, callbacks) => ({
    artProduct,
    callbacks,
  })
);
export const submitArtProductUpdate = createAction(
  'Submit art product update',
  (artProduct, callbacks) => ({
    artProduct,
    callbacks,
  })
);
export const submitArtProductDelete = createAction(
  'Submit art product delete',
  (artProductID, callbacks) => ({
    artProductID,
    callbacks,
  })
);
